import React from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const HeadBoyMessage = () => {
  useEffect(() => {
    document.title = 'Head Boy Message-  St. Francis Xavier School';  
}, []); 
    const [data, setData] = useState([]);
    useEffect(() => {
     const fetchData = async () => {
       try {
         const msgdata = await getPrincipalMessage();
        const data = msgdata.filter((item) => item.category === "HeadBoy");
        
         setData(data);
       } catch (error) {
         console.error("Error fetching online registration data:", error);
       }  
     };
     fetchData();
   }, []);
    return (
        <>
        <Header/>
        <div className="innerslide">
              <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>   
                <li>  Message</li>
                <li>Head Boy's Message</li>
              </ul>
          </div>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                {data.length > 0 && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt={data[0].name || 'Image'}
                      /></LazyLoad>
                      <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
                      <p className="name">
                        {data[0].name}<span> {data[0].category} </span>
                      </p>
                    </div>
                  )}

                  {data.length === 0  && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src="https://webapi.entab.info/api/image/SFXH/public/images/default.png" 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt=""
                      /></LazyLoad>
                      <p>Being a student of ST. FRANCIS XAVIER school from these many years, undoubtedly, I can say that it is the best institute to stay in. It is a confluence of well educated guiding lights. The teachers and all working staff who burn themselves to run this institution is great. </p>
                      <p>I am very grateful to the principal and school staff for believing in me and giving me the opportunity to serve my school. It is a matter of extreme honor to be elected as a head boy of such a great institute </p>
                      <p>I would like to thank all working members of this wonderful institution for giving me such moral and spiritual values which helped me to become worthy for being head boy. </p>
                      <p>Always remember... Its never about role, its about goal </p>
                      <p>So my dear fellow xavierites, let us pledge to unite and show up our strength to the world !! </p>
                      <p>Thank you</p>
                       <p className="name">Aryan 
                      <span> (Head Boy) </span>
                      </p>
                    </div>
                  )}
                </div> 
                </div> 
             </section>
            <Footer/>
        </>
    )
}

export default HeadBoyMessage